<script setup lang="ts">
import { AppButton } from '@libs/ui';

import { StaySelectionType } from '../../../models';
import type { Stay, StayId } from '../../../models';

interface HotelStayCardSummaryProps {
  stay: Stay;
}
const props = defineProps<HotelStayCardSummaryProps>();

interface HotelStayCardSummaryEmits {
  (eventName: 'stay-selected', stayId: StayId): void;
}

const emit = defineEmits<HotelStayCardSummaryEmits>();
</script>

<template>
  <div class="hotel-stay-card-summary">
    <div class="stay-summary">
      <div class="hotel-stay-price-summary">
        <div class="hotel-stay-nights">
          {{ $t('planner.total_for') }}
          {{ props.stay.numberOfNights }}
          {{ $t('planner.nights', props.stay.numberOfNights).toLowerCase() }}
        </div>

        <!-- TODO: Implement price -->
      </div>
      <AppButton
        :type="
          props.stay.selectionType === StaySelectionType.ManuallySelected
            ? 'important'
            : 'secondary'
        "
        state="enabled"
        size="medium"
        class="select-stay-button"
        @click="emit('stay-selected', props.stay.stayId)"
      >
        {{
          props.stay.selectionType === StaySelectionType.ManuallySelected
            ? $t('planner.continue_with_this_room')
            : $t('planner.select')
        }}
      </AppButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-stay-card-summary {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);

  .stay-summary {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-16);

    .hotel-stay-price-summary {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: var(--spacing-8);

      .hotel-stay-nights {
        color: var(--color-secondary-40);
        @include font-label-l-light;
        white-space: nowrap;
      }
    }
  }
}
</style>
